<template>
  <div id="photos-title-banner-component" class="text-white">
    <div 
      id="photos-content-row"
      class="row text-center">
        <div
          v-for="(photo, index) in photos"
          :key="index"
          class="col-12 col-sm-4 p-1">
          <PhotoListItem
            v-if="photo"
            class="bg-dark photo-home-list-item overflow-hidden"
            :item="photo"
            :isHome="true"
            @clicked="photo.title !== '' ? clickedItem(photo) : ''" />
          <PhotoListHomeItemEmpty
            v-else
            class="photo-home-list-item"/>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

import PhotoListItem from "@/components/PhotoListItem.vue"
import PhotoListHomeItemEmpty from "@/components/PhotoListHomeItemEmpty.vue";

import { usePhotoStore } from "@/stores/photo";

import { SEARCH_TYPE } from "@/constants";

// Define props in a class
class PhotoListHomePageProps {
  photos = prop({
    // Same as Vue core's prop option
    type: Array,
    required: true,
    default: []
  })
}

@Options({
  components: {
    PhotoListItem,
    PhotoListHomeItemEmpty
  }
})
export default class PhotoListHomePage extends Vue.with(PhotoListHomePageProps) {
  photoStore = usePhotoStore()

  public clickedItem(item: Record<string, any>) {
    console.log("clickedItem ", item)

    this.$router.push(`/photos/search/${SEARCH_TYPE.TITLE}?search_text=${item.title.toLowerCase()}&index=${(new Date()).toISOString()}&fromHome=${true}`);
  }
}
</script>

<style lang="stylus">
#photos-content-row {
  margin-left: auto
  margin-right: auto
}

.photo-home-list-item {
  height: 18rem;
}

</style>